module.exports = __webpack_public_path__ + "img/loading.e70fee8c.gif";